import axios from 'axios';
import { notifyUnauthorized } from './authEvents';

// Free-text updates someone posts about a company, reviewed into the activity history (and,
// optionally, an outreach-stage change) or dismissed.
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) notifyUnauthorized();
    return Promise.reject(error);
  }
);

const call = async (request, fallbackMessage) => {
  try {
    return (await request()).data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    throw new Error(typeof detail === 'string' ? detail : fallbackMessage);
  }
};

const companyUpdatesApi = {
  list: (companyId) => call(
    () => apiClient.get(`/api/v2/companies/${companyId}/updates`), "Couldn't load pending updates"),
  create: (companyId, body) => call(
    () => apiClient.post(`/api/v2/companies/${companyId}/updates`, { body }), "Couldn't post that update"),
  log: (id, { summary, outreach_stage }) => call(
    () => apiClient.post(`/api/v2/company-updates/${id}/log`, { summary, outreach_stage }), "Couldn't log that update"),
  dismiss: (id) => call(
    () => apiClient.post(`/api/v2/company-updates/${id}/dismiss`), "Couldn't dismiss that update"),
  history: (companyId, beforeId) => call(
    () => apiClient.get(`/api/v2/companies/${companyId}/history`,
      { params: beforeId ? { before_id: beforeId, limit: 20 } : { limit: 20 } }),
    "Couldn't load the activity history")
};

export default companyUpdatesApi;
